'use client'
import React, { useEffect, useState } from 'react'
import { useMainAppStore } from '../../shared/stores/mainAppStore'
import { usePathname } from 'next/navigation';

const NavigationProgressBar = () => {
    const [progress, setProgress] = useState(0);
    const pathname = usePathname();
    const { showNavProgressBar, setShowNavProgressBar } = useMainAppStore();
  
    useEffect(() => {
      if (!showNavProgressBar) return;
  
      setProgress(20);
  
      const interval = setInterval(() => {
        setProgress((p) => (p < 90 ? p + 20 : p));
      }, 800);
  
      return () => {
        clearInterval(interval);
      };
    }, [showNavProgressBar, setShowNavProgressBar]);

    useEffect(() => {
        setProgress(100);
        const timeout=  setTimeout(() => {
            setShowNavProgressBar(false)
        }, 800);

        return () => {
            clearTimeout(timeout)
        }
    }, [pathname, setShowNavProgressBar])
  
    if (!showNavProgressBar) return null;
    
  return (
    <div className={`pointer-events-none fixed left-0 z-[10000] h-[2px] top-0 transition-all duration-700 animate-pulse bg-primary`}
    style={{ width: `${progress}%` }}

    />
  )
}

export default NavigationProgressBar